import React from 'react';

const InfoBlock = ({title, children, subInfo}) => {
    return (
        <div className='info-block'>
            <div className="title">{title}</div>
            <div className="info">
                <span style={{fontFamily: "'Source_Sans3_bold', sans-serif"}}>{children}</span>
                {subInfo &&
                    <span className="sub-info">
                        ({subInfo})
                    </span>
                }
            </div>
        </div>
    );
};

export default InfoBlock;